module.exports = __webpack_public_path__ + "img/1553dcb.svg";